<template>
  <div>

  <div id="create-observation">
    <div class="col-12 mt-3" >
      <va-input
        :disabled="!canEdit"
        class="input-text"
        id="input-observations"
        type="textarea"
        :placeholder="$t('leads-web.details-modal.add-observations')"
        v-model.trim="currentObservation"
        :maxlength="255"
        :rows="3"
        @input="errors.clear('observations')"
        :error="errors.has('observations')"
        :error-messages="[$t(errors.get('observations'))]"
      />
    </div>
    <div class="row">
      <div class="col-12 text-right mt-3">
          <va-button type="button" :disabled="!currentObservation" @click="handleSendObs">{{$t('leads-web.details-modal.add-title')}}</va-button>
      </div>

    </div>
  </div>
    <hr class="separator-lead-details">
  <div id="observations mt-4">
    <h6 class="is-bold mb-4">{{ $t('leads-web.details-modal.observations').toUpperCase() }}</h6>
    <ul class="ml-3" v-if="observations && observations.length">
      <li v-for="obs in observations">
        <div class="is-bold d-inline-block ml-2">{{$t('leads-web.details-modal.observation-by', {date: $options.filters.localTime(obs.createdAt), by: obs.createdBy})  }}</div>
        <div class="label-text ml-2">{{ obs.content}}</div>
      </li>
    </ul>
    <div v-else><span>{{$t('leads-web.details-modal.no-observations')}}</span></div>
  </div>
  </div>

</template>

<script>
import Errors from '@/utils/StandardErrors'
import { LeadsWebService } from '@/api/LeadsWebService'
import { mapState } from 'vuex'

export default {
  props: {
    lead: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true,
      default: false
    },
  },
  created () {
    this.getLeadObservations()
  },
  data () {
    return {
      observations: [],
      currentObservation: null,
      errors: new Errors()
    }
  },
  methods: {
    getLeadObservations () {
      LeadsWebService.getLeadObservations(this.lead.id).then(data => {
        this.observations = data
      })
    },
    handleSendObs () {
      if (!this.currentObservation || this.currentObservation === '') {
        this.errors.set('observations', 'leads-web.errors.observations_cannot_be_empty')
      } else {
        const params = {
          content: this.currentObservation,
          createdBy: this.$auth.user().name,
          leadId: this.lead.id
        }

        LeadsWebService.createLeadObservation(params).then(res => {
          this.showToast(this.$t('leads-web.details-modal.observation-create-success'), this.$store.state.successToastOptions)

          this.observations.push(res)
          this.currentObservation = null
        }).catch(err => {
          console.log(err)
          this.showToast(this.$t('leads-web.details-modal.observation-create-error'), this.$store.state.errorToastOptions)
        })
      }
    }
  },
  computed: {
    ...mapState({
      'leadsWebToken': (state) => state.leadsWeb.leadsWebSrvToken
    }),
  },
}
</script>

<style lang="scss">
.va-input__container__content-wrapper {
  padding-left: 10px;
}
</style>
<style scoped lang="scss">
.input-text {
  background-color: #E8E8E8;
}
ul {
  list-style: none; /* Remove default bullets */
}

li {
  margin-bottom: 10px;
}

li::before {
  content: "";
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50px;
  background-color: #29C4AA;
  margin-left: -1em;
}

</style>
